import type { ReactNode } from 'react';

/** A loading indicator that keeps turning even with animations off. */
export function Spinner() {
  return <div className="spinner" />;
}

/** Content in the middle of the screen: loading, a message, a small form. */
export function CenterScreen({ children }: { children: ReactNode }) {
  return (
    <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ display: 'grid', justifyItems: 'center', gap: 14, textAlign: 'center', maxWidth: 420 }}>{children}</div>
    </div>
  );
}
